<!-- 复制源码可耻，使用或引用请注明来源：
作者：谢宝新
电话：13902658317
-->
<template>
	<article>
		<div class="divcontxt">

			<img class="logo" :src="imgsrclogo" />
			<div id="doorname" style="color: #ddd;"></div>
			<div id="doornamedv" style="color: #008000;">{{ability==1?'视频':'音频'}}接听中</div>

		</div>
		<div class="divhead" id="videos">
			<div class="wpbutton turn90" @click='turn90()'>
				<img class="imgbt" id="rotateIcon" src="../assets/turn90.png" />
				<span>旋转</span>
			</div>
			<video id="remoteVideo" ref="remoteVideo" style="object-fit:fill" :muted="true" preload="auto"
				autoplay="autoplay" x-webkit-airplay="true" playsinline="true" webkit-playsinline="true"
				x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portraint"></video>
			<div class="arc" id="loading"></div>
			<canvas id="canvas"></canvas>
		</div>
		<div class="divcontrol">
			<div class="divctrl" v-if="imcall">

				<div class="wpbutton" id="speaker" @click="setlocalspeak()">
					<img class="imgbt" :src="imgsrcspeek" />
					<span>免提</span>
				</div>
				<section v-for="item in myaction" :key="item.actdo">
					<div class="wpbutton" @click='opendoor(item.actdo)'>
						<img class="imgbt" src="../assets/open_door.png" />
						<span>{{item.btname}}</span>
					</div>
				</section>

				<div class="wpbutton" @click="hangup()">
					<img class="imgbt" src="../assets/hangup.png" />
					<span>挂断</span>
				</div>
			</div>
			<div class="divctrl" v-else>
				<!-- <div class="imgbutton" @click="scanpicture()">
					<img class="imgbt" :src="imgsrcscan" />
				</div>
				<div class="imgbutton1" @click="webrtcrecord()">
					<img class="imgbt" :src="imgsrcrecord" />
				</div>

				<div class="imgbutton1" @click="setlocalspeak()">
					<img class="imgbt" :src="imgsrcaudio" />
				</div>
-->
				<div class="wpbutton" id="speaker" @click="setlocalspeak()">
					<img class="imgbt" :src="imgsrcspeek" />
					<span>免提</span>
				</div>

				<div class="wpbutton" @click="hangup()">
					<img class="imgbt" src="../assets/hangup.png" />
					<span>挂断</span>
				</div>

				<div class="wpbutton" id="callon" @click="Callon()">
					<img class="imgbt" src="../assets/call.png" />
					<span>接听</span>
				</div>

				<section v-for="item in myaction" :key="item.actdo">
					<div class="wpbutton" @click='opendoor(item.actdo)'>
						<img class="imgbt" src="../assets/open_door.png" />
						<span>{{item.btname}}</span>
					</div>
				</section>

				<div class="wpbutton" v-if="allowvideo" id="sertability" @click="sertability()">
					<div class="roundbutton showact"><img class="imgbt" src="../assets/camera_on.png" /></div>
					<div class="roundbutton"><img class="imgbt" src="../assets/camera_off.png" /></div>
					<span>视频</span>
				</div>


			</div>
		</div>

	</article>
</template>



<script>
	import imga_1 from "../assets/ic_video_photo.png";
	import imgb_1 from "../assets/ic_video_record.png";
	import imgb_2 from "../assets/play_video_record.png";
	import imgc_1 from "../assets/ic_video_stop.png";
	import imgc_2 from "../assets/ic_video_stop_land.png";
	import imgd_1 from "../assets/ic_video_unlock.png";
	// import imgd_2 from "../assets/ic_video_unlock_land.png";
	// import imgd_do from "../assets/open_door.png";

	import axios from 'axios';

	const uni = require('../comjs/uni.webview.1.5.4');


	// const baseaxurl = 'https://rtc.wangpeiaiot.com/prod-api/';
	// const baseaxurl = 'https://42.194.225.81:8080/jeecg-boot/';
	// const baselogo = "https://aic.wangpeiaiot.com/lpro/image/oss/iot/logos";

	export default {
		name: 'HelloWorld',
		metaInfo: {
			title: "易家人视频",
			meta: [
				{name: "http-equiv", content: "Content-Security-Policy"},
				{name: "content", content: "upgrade-insecure-requests"},
			],
		},
		props: {
			msg: String
		},
		data() {
			return {
				imgsrcscan: imga_1,
				imgsrcrecord: imgb_1,
				imgsrcspeek: imgc_2,
				imgsrcaudio: imgd_1,
				IsLocalDataChannel: true,
				isAndroid: false,
				isIos: false,
				isChrome: false,
				isWeixin: false,
				websock: null,
				connected: false,
				connecting: false,
				videoplaying: false,
				socketTask: false,
				startRecive: false,
				StartCalled: false,
				CheckedgetUserMedia: false,
				IsWebSocketCreateed: false,
				IsWebSocketConnecting: false,
				IsWebSocketOpened: false,
				IsLocalAudioTrack: false,
				IsLocalVideoTrack: false,
				IsSystemAudioDeviceOK: false,
				IsFailCreate: false,
				recorded: false,
				speak: false,
				mute: false,
				myPeerConnection: null,
				myDataChannel: null,
				stream: null,
				remoteMediaStream: null,
				mediaRecorder: null,
				remoteVideo: null,
				heartCheck: null,
				messagecallback: null,
				RTCPeerConnectionCreated: false,
				peerid: '',
				meid: '',
				userid: '',
				device_id: '',
				host: '',
				calltime: null,
				sessionId: '',
				wsurl: '',
				url: '',
				mymsg: false,
				roomId: '',
				IsReconnect: false,
				timeout: 2000,
				timedelay: 0,
				serverTimeoutObj: null,
				IceCandidate: new Array(),
				connectmode: "live",
				connectsource: "MainStream",
				configuration: {
					"iceServers": [{
						'urls': ['stun:webrtc.qq-kan.com:3478?transport=udp']
					}]

				},
				inittoken: "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImIwMTQwYjM4LTg4NTEtNDMxMy1hYzY2LWY0Nzg2OWE2YTEyNiJ9.87k8hrGKwx5MWxWFyX_3vyvWakgt",
				imgsrclogo: '',
				// remoteurl: 'https://admin.bzy2015.com/jeecg-boot/',
				remoteurl: 'https://admin.bzy2015.com/jeecg-boot/',
				imcall: false, //直接接通
				allowvideo: true, //允许视频
				ability: 1, //0单向视频1双向视频 默认单向
				myaction: [],
				myactiontmp: [],
				rotation: 0.0


			}
		},
		created() {
			// this.imgsrclogo = baselogo + "1.png";

			this.calltime = this.getQueryString("time");

			var url = window.location.href;
			console.log('created  -----url =  ', url);

			var serno = this.getQueryString("serno");
			if (serno != null) {
				this.peerid = serno;
			} else {
				alert('参数错误');
				return;
			}

			this.sessionId = this.newGuid();
			this.meid = this.newGuid();

			var selfpeerid = this.getQueryString("selfpeerid");
			if (selfpeerid != null) {
				this.userid = selfpeerid;
				this.meid = selfpeerid;
			} else {
				alert('参数错误');
				return;
			}


			var device_id = this.getQueryString("device_id");
			if (device_id == null) {
				this.device_id = this.peerid;
			} else {
				if (device_id != '')
					this.device_id = device_id;
				else {
					alert('无效设备id');
					return false;
				}
			}

			document.title = "易家人视频对讲";

			var host = this.getQueryString("server")
			if (host == null || host == "") {
				this.host = 'box.wangpeiaiot.com';
			} else
				this.host = host;
			this.host = 'box.chinahjz.cn'


			var toability = this.getQueryString("ability");
			if (toability != null && toability >= 0) {
				this.ability = toability;
			}

			// this.remoteurl = baseaxurl;
			if (this.getQueryString("apiserv") != '') {
				this.remoteurl = this.getQueryString("apiserv");
			}

			if (this.getQueryString("device") != 'no') {
				this.getappinfo();
			}
			if (this.getQueryString("im") == 1) {
				this.imcall = true;
			}

			// if (this.getQueryString("video") == 'no') {
			// 	this.allowvideo = false;
			// }
			if (this.getQueryString("video") == '0') {
				this.allowvideo = false;
			}

			var showlock = this.getQueryString("lock");
			if (showlock != 'no') {
				this.myaction = [{
					'btname': '开锁',
					'actdo': 'openDoor'
					// 'iconsrc': imgd_do, //"../assets/open_door.png",
					//   'display': 'none",
				}];
			}
			if (this.checktimesign()) {
				this.initWebSocket();
			}

		},
		mounted() {
			var Videos = document.getElementById('videos');
			var canvas = document.getElementById('canvas');
			var loading = document.getElementById('loading');
			canvas.style.display = "none";

			if (!this.imcall && this.allowvideo)
				document.getElementById('sertability').style.display = 'none';

			var u = window.navigator.userAgent;
			if (u != null) {
				this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
				this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
				this.isChrome = u.indexOf("Chrome") !== -1 //Chrome 浏览器
				this.isWeixin = u.indexOf('micromessenger') != -1; //微信浏览器
			}
			if (this.isIos || this.isAndroid) {

				// Videos.style.width = "100%";
				// Videos.style.height = Math.floor(document.documentElement.clientWidth * 9 / 16) + "px";

				loading.style.left = Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
				loading.style.top = Math.floor(document.documentElement.clientWidth * 9 / 16 / 2 - 25) + "px";
			} else {


				// Videos.style.width = "100%";
				var temheight = Math.floor(document.documentElement.clientWidth * 9 / 16);
				if (temheight > document.documentElement.clientHeight - 60) {
					// Videos.style.height = Math.floor(document.documentElement.clientHeight - 60) + "px";
					loading.style.left = Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
					loading.style.top = Math.floor(Videos.style.height / 2 - 25) + "px";

				} else {
					// Videos.style.height = Math.floor(document.documentElement.clientWidth * 9 / 16) + "px";
					loading.style.left = Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
					loading.style.top = Math.floor(document.documentElement.clientWidth * 9 / 16 / 2 - 25) + "px";
				}


			}

			loading.style.top = '45vh';
			var doorname = this.getQueryString("doorname");
			if (doorname != null) {
				doorname = decodeURI(this.getQueryVariable('doorname'));
				document.title = doorname;
				document.getElementById('doorname').innerHTML = doorname;
			}


			this.remoteVideo = document.getElementById("remoteVideo");
			// if (this.remoteVideo != null) {
			// 	this.remoteVideo.volume = 100; // 增大音量，值可以根据需要调整
			// }
			if (this.remoteVideo != null) {

				if (!this.allowvideo)
					this.remoteVideo.style.display = 'none';

				this.remoteVideo.muted = true;

				this.remoteVideo.addEventListener('playing', this.OnVideoPlaying);
				this.remoteVideo.addEventListener('play', this.OnVideoPlay);
				this.remoteVideo.addEventListener('loadedmetadata', this.OnVideoLoadedMetaData);
				this.remoteVideo.addEventListener('canplay', this.OnVideoCanPlay);
				this.remoteVideo.addEventListener('error', this.OnVideoError);
				this.remoteVideo.addEventListener('loadeddata', this.OnVideoLoadedData);

				if (this.isWeixin == true && this.isIos == false) {
					console.log("Your browser Weixin  no ios");

				} else if (this.isWeixin == true && this.isIos == true) {
					console.log("Your browser Weixin addEventListener WeixinJSBridgeReady");
					document.addEventListener("WeixinJSBridgeReady", function() {
						var that = this;
						if (this.videoplaying == false) {
							this.videoplaying = true;
							var playPromise = this.remoteVideo.play();
							if (playPromise) {
								playPromise.then(() => {
									that.videoplaying = true;
									console.log("browser Weixin <video> play.");

								}).catch((e) => {
									that.videoplaying = false;
									console.log("<video> play error ", e.message);
								});
							}
						}

					}, false);
				} else {
					if (this.isChrome == true && this.isIos == false) {
						console.log("Your browser isChrome  no ios");
					} else {
						console.log("Your browser isChrome   ios");
					}
				}

			}

			if (!this.checktimesign()) {
				alert('呼叫已过期');
				this.hangup();
				return false;
			}

			document.addEventListener('plusready', function() {
				// plus.camera.getCamera();
				// const a = plus.audio.getRecorder();
				// a.record();
				// a.stop();
			});

			this.NewgetUserMedia({
				video: this.allowvideo,
				audio: true
			}, this.streamHandler, this.errorHandler);
			this.timerstart();

			let _this = this; //赋值vue的this
			window.onresize = () => {
				_this.pageResize();
			}

			document.addEventListener('UniAppJSBridgeReady', function() {
				uni.getEnv(function(res) {
					console.log('onready--当前环境：' + JSON.stringify(res));
				});
			});
			// console.log('mounted  -----remotevideo ',this.remoteVideo);

		},
		destroyed() {

			window.onresize = null;
			if (this.websock != null) {
				this.websock.close();
			}

			if (this.stream != null) {
				this.hangup();
			}

		},
		methods: {

			getQueryVariable(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return (false);
			},

			hangup() {
				console.log('-----close id----');
				if (this.stream != null) {
					this.stream.getTracks().forEach((track) => {
						track.stop(); // 关闭摄像头和mic
					});

					window.localStream = null;
					this.stream = null;
				}

				var param = {
					cmd: 'handup', //openDoor,handup,accept,refuse
					selfId: this.userid,
					sessionId: this.sessionId,
					deviceId: this.device_id,
				};
				this.posecmd(param, '/mqtt/callSync', 'hangup');

				this.PostMessage("handup");
				// document.getElementById('remoteVideo')?.style.width = "0%";

				document.getElementById('loading').style.display = 'none';
				document.getElementById('app').style.display = 'none';
				document.getElementById('app').parentNode.innerHTML = "<p ><b style='color:red'>通话已结束</b></p>";
				this.speak = false;
				this.mute = false;
				this.videoplaying = false;
				this.calltime = null;

				this.sendDisconnect();
				this.handleLeave();
				this.timerreset()
				this.close();
				if (this.websock != null) {
					this.websock.close();
					this.websock = null;
				}

				uni?.navigateBack({
					delta: 1
				});

			},
			sertability() {
				this.ability = (this.ability == 0 ? 1 : 0);

				var oli = document.getElementsByClassName('showact')[0];
				var lis = document.getElementsByClassName('roundbutton');
				for (var index = 0; index < lis.length; index++) {
					if (lis[index] != oli) {
						lis[index].className = "roundbutton showact";
					} else {
						lis[index].className = "roundbutton";
					}
				}

				var thsat = this;

				// this.myPeerConnection.getReceivers().forEach(function(receiver) {
				// 	if (receiver.track != null && receiver.track.kind === 'video') {
				// 		receiver.track.enabled = (thsat.ability==1);
				// 	}
				// });


				this.myPeerConnection.getSenders().forEach(function(sender) {
					if (sender.track != null && sender.track.kind === 'video') {
						sender.track.enabled = (thsat.ability == 1);
					}
				});

				document.getElementById('doornamedv').innerHTML = "<b>" + (thsat.ability == 1 ? "视频" : "音频") + "通话中</b>";

			},
			Callon() {
				// console.log(this.getQueryString("device"))
				// if (this.getQueryString("device") == 'no') {
				// 	return this.callinvite();
				// }

				var param = {
					cmd: 'accept',
					sessionId: this.sessionId,
					selfId: this.userid,
					deviceId: this.device_id,
				};

				this.posecmd(param, '/mqtt/callSync', 'callon')
			},
			opendoor() {
				var param = {
					cmd: 'openDoor',
					userId: this.userid,
					clientId: this.device_id,
				};
				if (this.myPeerConnection != null) {
					// this.PostMessage("openDoor");
					axios({
							method: 'get',
							url: '/mqtt/open-door',
							baseURL: this.remoteurl,
							headers: {
								'Access-Control-Allow-Origin': '*',
								'token': "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImIwMTQwYjM4LTg4NTEtNDMxMy1hYzY2LWY0Nzg2OWE2YTEyNiJ9.87k8hrGKwx5MWxWFyX_3vyvWakgt",
							},

							params: param,
						})
						.then(res => {
							console.log(res.data);
							console.log("open door  -------------------------------------- ");

						})
						.catch(error => {
							console.log(error);
						});

					this.PostMessage("openDoor");

				}
			},

			posecmd(parame, axurl, action) {
				console.log("---posecmd:", this.remoteurl, axurl, parame);
				if (this.myPeerConnection != null) {
					axios({
							method: 'post',
							url: axurl,
							baseURL: this.remoteurl,
							headers: {
								'Access-Control-Allow-Origin': '*',
								// 'Content-Type': "application/x-www-form-urlencoded",
								// 'token': "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImIwMTQwYjM4LTg4NTEtNDMxMy1hYzY2LWY0Nzg2OWE2YTEyNiJ9.87k8hrGKwx5MWxWFyX_3vyvWakgt",
							},

							// data: parame,
							params: parame,
						})
						.then(res => {
							console.log(res.data);
							if (res.data.retCode == 200) {
								if (action == 'callon') {
									this.callinvite();
								}

							}

						})
						.catch(error => {
							console.log(error);
						});
				}

			},

			getappinfo() {
				var param = {
					deviceId: this.device_id
				};
				axios({
						method: "get",
						url: "device/dcit/api/eq/v1/get-appid",
						baseURL: this.remoteurl,
						headers: {
							"Access-Control-Allow-Origin": "*",
							// "Content-Type": "application/x-www-form-urlencoded",
							// token: this.inittoken,
						},

						// data: param,
						params: param,
					})
					.then((res) => {
						console.log(res.data);
						if (res.data.retCode == 200) {

							var doorname = res.data.data.doorname;
							document.title = doorname;

							// var appid = res.data.data.operId;
							// this.imgsrclogo = baselogo + appid + ".png";
							if (res.data.data.logo != '') {
								this.imgsrclogo = res.data.data.logo;
							}

							// if (res.data.data.realDeviceId != '')
							// 	this.device_id = res.data.data.realDeviceId;
							//
							// if (res.data.data.url != '') {
							// 	this.remoteurl = res.data.data.url;
							// }

							// this.peerid = res.data.data.meid;
							// this.inittoken = res.data.data.token;
							// this.ability=res.data.data.ability;
							// this.myactiontmp=res.data.data.action;


						} else {
							alert(res.data.message);
							// this.hangup();
							// return false;
						}
					})
					.catch((error) => {
						console.log(error);
						// this.hangup();
						// return false;
					});
			},
			// https://rtc.wangpeiaiot.com/dist/?serno=WPWL-00-C2NB-OE1X-00000005&selfpeerid=13531703369&device_id=29287&device=no&lock=no&myvideo=no&time=1&im=1

			callinvite() {
				if (!this.imcall) {
					document.getElementById('callon').style.display = "none";

					if (this.getQueryString("myvideo") != 'no' && this.allowvideo) {
						document.getElementById('sertability').style.display = 'block';
					}

				}

				console.log("call on  -------------------------------------- ");

				this.myPeerConnection.getReceivers().forEach(function(receiver) {
					if (receiver.track != null && receiver.track.kind === 'audio') {
						receiver.track.enabled = true;
						console.log("PeerConnection  getReceivers  true  -------------------------------------- ",
							receiver);
					}
				});

				this.mute = true;
				// this.speak = true;
				this.imgsrcspeek = imgc_1;

				if (this.remoteVideo != null) {
					if (this.remoteVideo.muted == true) {
						this.remoteVideo.muted = false;
					}
				}
				this.myPeerConnection.getSenders().forEach(function(sender) {

					if (sender.track != null && sender.track.kind === 'audio') {
						sender.track.enabled = true;

						console.log("PeerConnection  getSenders  true  -------------------------------------- ",
							sender);
					}
				});

				this.myPeerConnection.getReceivers().forEach(function(receiver) {

					if (receiver.track != null && receiver.track.kind === 'audio') {
						receiver.track.enabled = true;
						console.log("PeerConnection  getReceivers  true  ------------------ ", receiver);
					}
				});

				// if (this.myactiontmp.length > 0) {
				// 	this.myaction = this.myactiontmp.filter(item => item.display!='none');
				// }

				document.getElementById('doornamedv').innerHTML = "<b>通话中</b>";

				this.PostMessage("callon");

			},

			checktimesign() {
				var nowtime = (new Date()).valueOf();
				if (this.calltime != null && this.calltime == 1)
					return true;

				if (this.calltime == null || (nowtime - (+this.calltime)) > 45 * 1000) {
					return false;
				}
				return true;

			},
			// ----------------------


			webrtcrecord() {
				if (this.videoplaying == true) {
					if (this.recorded) {
						this.stoprecord();
						this.imgsrcrecord = imgb_1;
					} else {
						this.startrecord();
						this.imgsrcrecord = imgb_2;
					}
				} else {
					this.imgsrcrecord = imgb_1;
				}
			},
			setlocalspeak() {
				// var that = this;
				if (this.myPeerConnection != null) {

					this.speak = !this.speak;
					if (this.speak == true) {

						this.imgsrcspeek = imgc_1;
					} else {

						this.imgsrcspeek = imgc_2;
					}
					if (this.remoteVideo != null) {
						if (this.remoteVideo.muted == true) {
							this.remoteVideo.muted = false;
						}
					}

					console.log("PeerConnection  setlocalspeak :   ------------- ", this.speak);
					this.myPeerConnection.getReceivers().forEach(function(receiver) {


						if (receiver.track != null && receiver.track.kind === 'audio') {
							receiver.track.enabled = true;

							try {
								// 获取音频轨道
								// let audioTrack = myPeerConnection.getReceivers().find(receiver => receiver.track.kind === 'audio').track;
								let audioTrack = receiver.track;
								// 获取音频轨道的音量控制
								let audioTrackSettings = audioTrack.getSettings();
								let audioOutput = audioTrack.getCapabilities().output;

								if (audioOutput && audioOutput.length > 0) {
									const speakerEnabled = !audioTrackSettings.echoCancellation;

									audioTrack.applyConstraints({
											echoCancellation: !speakerEnabled
										})
										.then(() => {
											console.log(`免提已${speakerEnabled ? '关闭' : '开启'}`);
										})
										.catch(error => {
											console.error('切换免提时出现错误：', error);
										});
								} else {
									console.warn('设备不支持切换免提');
								}


								// var set = receiver.track.getSettings();
								// console.log(set);
								// if ( == true) {
								// 	set.audioTracks[0].setMode("speakerphone")
								// } else {
								// 	var c = set.noiseSuppression;
								// 	const promise = receiver.track.applyConstraints(Object.assign(receiver.track
								// 		.getSettings(), c))
								// 	console.log(promise);
								// }

							} catch (e) {
								console.log(e);
							}




						}
					});

				}
			},

			startrecord() {
				var that = this;
				if (this.remoteMediaStream != null) {

					this.mediaRecorder = new MediaRecorder(this.remoteMediaStream);
					if (this.mediaRecorder != null) {
						console.log("mediaRecorder  startrecord    -------------------------------------- ");
						this.recorded = true;
						this.mediaRecorder.blobs = [];
						this.mediaRecorder.ondataavailable = function(e) {
							that.mediaRecorder.blobs.push(e.data);
						};
						this.mediaRecorder.onstop = function(e) {
							// console.log("mediaRecorder  onstop    -------------------------------------- ",e);
							if (e.type == 'stop' && that.mediaRecorder.blobs.length) {
								var recorderFile = new Blob(that.mediaRecorder.blobs, {
									'type': that.mediaRecorder.mimeType
								});
								var downloadUrl = window.URL.createObjectURL(recorderFile);
								var link = document.createElement('a');
								link.style.display = 'none';
								link.href = downloadUrl;
								link.download = new Date().valueOf() + 'a.webm';
								//link.disabled = false;
								//link.click();

								var downloade = document.createEvent('MouseEvents');
								downloade.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false,
									false, false, 0, null);
								link.dispatchEvent(downloade);
								URL.revokeObjectURL(downloadUrl);

							}
						};
						this.mediaRecorder.start();
					}
				}
			},
			stoprecord() {
				if (this.recorded == true && this.remoteMediaStream != null && this.mediaRecorder != null) {
					// console.log("mediaRecorder  stoprecord    -------------------------------------- ");
					this.mediaRecorder.stop();
					this.recorded = false;
				}
			},
			scanpicture() {
				if (this.videoplaying == true) {
					var canvas = document.getElementById('canvas');
					var video = document.getElementById('remoteVideo');
					var context = canvas.getContext('2d');
					context.drawImage(video, 0, 0, canvas.width, canvas.height);
					var data = canvas.toDataURL('image/png');
					console.log("PeerConnection  scanpicture    -------------------------------------- ", data);
				}

			},
			AndroidSaveVideoFile(blob) {
				window.AndroidWebView.SaveVideoFile(blob);
			},
			pageResize() {
				// var Videos = document.getElementById('videos');
				var loading = document.getElementById('loading');
				if (this.isIos || this.isAndroid) {

					// Videos.style.width = "100%";
					// Videos.style.height = Math.floor(document.documentElement.clientWidth * 9 / 16) + "px";

					loading.style.left = Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
					loading.style.top = Math.floor(document.documentElement.clientWidth * 9 / 16 / 2 - 25) + "px";
				} else {


					// Videos.style.width = "100%";
					var temheight = Math.floor(document.documentElement.clientWidth * 9 / 16);
					if (temheight > document.documentElement.clientHeight - 60) {
						// Videos.style.height = Math.floor(document.documentElement.clientHeight - 60) + "px";
						loading.style.left = Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
						// loading.style.top = Math.floor(Videos.style.height / 2 - 25) + "px";

					} else {
						// Videos.style.height = Math.floor(document.documentElement.clientWidth * 9 / 16) + "px";
						loading.style.left = Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
						loading.style.top = Math.floor(document.documentElement.clientWidth * 9 / 16 / 2 - 25) + "px";
					}



				}

				loading.style.top = '45vh';

			},
			timerreset() {
				clearTimeout(this.timeoutObj);
				clearTimeout(this.serverTimeoutObj);
			},
			timerstart() {
				var that = this;
				this.serverTimeoutObj = setInterval(function() {
					that.timedelay++;
					if (that.websock && that.websock.readyState === 1) {
						if (that.IsReconnect == true) {
							console.log("reconnect  ------------------- ");
							if (that.RTCPeerConnectionCreated == true) {
								that.handleLeave();
							}
							that.StartCalled = false;
							that.sessionId = that.newGuid();
							that.Connect();
						} else {
							if (that.timedelay > 30) {
								that.timedelay = 0;
								that.sendToServer({
									"eventName": "__ping",
									"data": {
										"sessionId": that.sessionId,
										"sessionType": "IE",
										"messageId": that.newGuid(),
										"from": that.meid,
										"to": that.peerid
									}
								});
							}
						}
						that.timerreset();
						that.timerstart();
					} else {
						if (that.IsWebSocketConnecting == false) {
							if (that.websock != null) {
								that.websock.close();
								that.websock = null;
							}
							if (that.RTCPeerConnectionCreated == true) {
								that.handleLeave();
							}
							// that.meid = that.newGuid();

							that.initWebSocket();
						} else {
							console.log("IsWebSocketConnecting  ------------------- ");
						}
					}
				}, this.timeout)
			},
			initWebSocket() {
				if (this.IsWebSocketConnecting == true) {
					return;
				}
				// var ishttps = 'https:' == document.location.protocol ? true : false;
				this.IsWebSocketConnecting = true;
				var wsuri = '';


				wsuri = 'wss://' + this.host + '/wswebclient/' + this.meid;

				// if (this.host == "localhost:8080" || this.host == "") {
				//
				//
				// 	if (ishttps) {
				// 		wsuri = 'wss://webrtc.qq-kan.com/wswebclient/' + this.meid;
				// 	} else {
				// 		wsuri = 'ws://webrtc.qq-kan.com/wswebclient/' + this.meid;
				// 	}
				//
				// } else {
				// 	if (ishttps) {
				// 		wsuri = 'wss://' + this.host + '/wswebclient/' + this.meid;
				// 	} else {
				// 		wsuri = 'ws://' + this.host + '/wswebclient/' + this.meid;
				// 	}
				//
				//
				// }
				console.log('initWebSocket  --------', wsuri);

				//https://dev.51hjk.com:4439/videocall/SHJT-00-RLRM-H9PW-00000012

				// const wsuri = 'wss://webrtc.qq-kan.com/wswebclient/'+this.meid;
				//const wsuri = 'wss://dev.51hjk.com:4439/wswebclient/'+this.meid;
				if (this.websock != null) {
					this.websock.close();
					this.websock = null;

				}
				this.websock = new WebSocket(wsuri);
				this.websock.onmessage = this.websocketonmessage;
				this.websock.onopen = this.websocketonopen;
				this.websock.onerror = this.websocketonerror;
				this.websock.onclose = this.websocketclose;
			},
			websocketonopen() {
				var that = this;
				this.IsWebSocketOpened = true;
				if (this.websock != null && this.websock.readyState === 1) {
					this.StartCalled = false;
					this.Connect();

				} else {
					setTimeout(() => {
						if (that.websock != null && that.websock.readyState === 1) {
							that.StartCalled = false;
							that.Connect();
						}
					}, 100);
				}


			},
			websocketonerror(e) { //连接建立失败重连
				this.IsWebSocketOpened = false;
				this.IsWebSocketConnecting = false;
				this.websock = null;
				console.log('连接错误', e);
				//this.meid=this.newGuid();
				//this.initWebSocket();
			},
			websocketonmessage(e) { //数据接收
				const data = JSON.parse(e.data);
				console.log(
					"-->>>>>>>>>>>>websocket--- onmessage--:" + data.eventName, data
				);
				switch (data.eventName) {
					case "_create":
						this.handleCreate(data.data);
						break;
					case "_offer":
						this.handleOffer(data.data);
						break;
					case "_answer":
						this.handleAnswer(data.data);
						break;
					case "_ice_candidate":
						this.handleCandidate(data.data);
						break;
					case "_session_disconnected":
						console.log("_session_disconnected............")
						// this.handleDisconnect(data.data);
						// this.hangup();
						break;
					case "_disconnect":
						console.log("_disconnect............")
						this.hangup();
						break;
					case "_post_message":
						this.handlePostMessage(data.data);
						break;
					case "_connectinfo":
						this.handleConnectInfo(data.data);
						break;
					case "_session_failed":
						this.handleSessionFailed(data.data);
						break;
					case "_ping":
						break;
					default:
						console.log("Got default message", data);
						break;
				}
			},
			websocketsend(Data) { //数据发送
				if (this.websock != null && this.websock.readyState === 1) {
					this.websock.send(Data);
				}

			},
			websocketclose(e) { //关闭
				this.IsWebSocketOpened = false;
				this.IsWebSocketConnecting = false;
				this.websock = null;
				console.log('断开连接', e);
			},
			getQueryString(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				var reg_rewrite = new RegExp("(^|/)" + name + "/([^/]*)(/|$)", "i");
				var r = window.location.search.substr(1).match(reg);
				var q = window.location.pathname.substr(1).match(reg_rewrite);
				if (r != null) {
					return unescape(r[2]);
				} else if (q != null) {
					return unescape(q[2]);
				} else {
					return null;
				}
			},
			NewgetUserMedia(constrains, success, error) { //访问用户媒体设备的兼容方法
				console.log("NewgetUserMedia----------------");

				if (window.navigator.mediaDevices && window.navigator.mediaDevices.getUserMedia) { //最新标准API
					window.navigator.mediaDevices.getUserMedia(constrains).then(success).catch(error);
				} else if (window.navigator.webkitGetUserMedia) { //webkit内核浏览器
					window.navigator.webkitGetUserMedia(constrains).then(success).catch(error);
				} else if (window.navigator.mozGetUserMedia) { //Firefox浏览器
					window.navagator.mozGetUserMedia(constrains).then(success).catch(error);
				} else if (window.navigator.getUserMedia) { //旧版API
					window.navigator.getUserMedia(constrains).then(success).catch(error);
				} else if (window.navigator.msGetUserMedia) {
					window.navigator.msGetUserMedia(constrains).then(success).catch(error);
				} else {
					this.CheckedgetUserMedia = false;
					this.IsLocalAudioTrack = false;
					console.log("Your browser no getUserMedia function");


				}
			},
			Connect() {
				this.sendToServer({
					"eventName": "__connectto",
					"data": {
						"sessionId": this.sessionId,
						"sessionType": "IE",
						"messageId": this.newGuid(),
						"from": this.meid,
						"to": this.peerid
					}
				});
			},
			handleDisconnect(data) {
				this.hangup()
				if (data.sessionId == this.sessionId) {
					console.log("handleDisconnect ", JSON.stringify(data));
					if (this.RTCPeerConnectionCreated == true) {
						this.handleLeave();
					}

				}
			},
			sendToServer(message) {
				console.log("------>>>>>>>>>>websocket---send : ", message);

				this.websocketsend(JSON.stringify(message));
			},
			PostMessage(cmdmessage, callback) {
				var messageid = this.newGuid();
				this.messagecallback = callback;
				this.sendToServer({
					"eventName": "__post_message",
					"data": {
						"sessionId": this.sessionId,
						"sessionType": "IE",
						"messageId": messageid,
						"to": this.peerid,
						"from": this.meid,
						"message": cmdmessage
					}
				});

				if (this.myDataChannel) {
					console.log("---myDataChannel.send");
					this.myDataChannel.send(JSON.stringify({
						"sessionId": this.sessionId,
						"sessionType": "IE",
						"messageId": messageid,
						"to": this.peerid,
						"from": this.meid,
						"title": "siren",
						"sequence": 0,
						"payload": {
							"cmd": cmdmessage,
							"alarm_audio": true
						}
					}));
				}

			},
			handlePostMessage(data) {
				console.log("handlePostMessage  recv    -------------------------------------- ", data);
				if (this.messagecallback === undefined || this.messagecallback === null) {
					console.log("handlePostMessage");
				} else {
					typeof(this.messagecallback) === 'function' && this.messagecallback(data.message);
					this.messagecallback = null;
				}
			},
			handleSessionFailed(data) {
				console.log("handleSessionFailed ", data);
				if (data.sessionId == this.sessionId) {
					if (this.RTCPeerConnectionCreated == true) {
						this.handleLeave();
						this.sendDisconnect();
					}
					this.sessionId = this.newGuid();
				}

			},
			handleCreate(data) {
				// console.log("WebSocket _create", data);
				if (data.state === "online" || data.state === "sleep") {
					this.IsWebSocketCreateed = true;
					if (data.iceServers !== null || data.iceServers !== undefined || data.iceServers !== '') {
						// console.log("WebSocket iceServers", data.iceServers);
						//服务器把ICE 服务的信息下发到js创建RTCPeerConnection使用
						//configuration = JSON.parse(data.iceServers);
						if (data.iceServers.constructor === Object) {
							// console.log(" _create  iceServers ---object ---- ", JSON.stringify(data.iceServers));
							this.configuration = JSON.parse(JSON.stringify(data.iceServers));
						} else {
							// console.log(" _create  iceServers ---string ---- :", data.iceServers);
							this.configuration = JSON.parse(data.iceServers);
						}
					}
					if (this.CheckedgetUserMedia == true && this.StartCalled == false) {
						// console.log("handleCreate  start call");
						this.Call();
					} else {
						console.log("handleCreate  CheckedgetUserMedia =", this.CheckedgetUserMedia, " StartCalled=", this
							.StartCalled);

					}
				}

				if (data.state === "offline") {
					this.hangup();
					alert("对方已挂断");
					// console.log(" _create  offline  ", data.from);
				}
			},
			Call() {
				console.log("call");
				this.StartCalled = true;
				var audioenable = "sendrecv";
				var videoenable = "sendrecv";
				var datachannelenable = "true";
				if (this.IsLocalDataChannel == false) {
					datachannelenable = "false";
				}
				if (this.IsLocalAudioTrack == false) {
					audioenable = "recvonly";
				}
				if (this.IsLocalVideoTrack == false) {
					videoenable = "recvonly";
				}
				//audioenable = "sendonly";
				//videoenable = "sendonly";
				//datachannelenable = "true";
				console.log("call audio --------------", audioenable, " video ", videoenable, " datachannel",
					datachannelenable);
				this.sendToServer({
					"eventName": "__call",
					"data": {
						"sessionId": this.sessionId,
						"sessionType": "IE",
						"messageId": this.newGuid(),
						"from": this.meid,
						"to": this.peerid,
						"mode": this.connectmode,
						"source": this.connectsource,
						"datachannel": datachannelenable,
						"audio": audioenable,
						"video": videoenable,
						"user": "admin",
						"pwd": "123456",
						"iceservers": JSON.stringify(this.configuration)
					}
				});
			},
			handleConnectInfo(data) {
				console.log("Got ConnectInfo Message:", data.message);
			},
			handleLeave() {
				// console.log('handleLeave  --------');
				var that = this;

				if (this.myDataChannel != null) {
					this.myDataChannel.close();
					this.myDataChannel.onopen = null;
					this.myDataChannel.onclose = null;
					this.myDataChannel.onmessage = null;
					this.myDataChannel.onerror = null;
					this.myDataChannel = null;
				}
				if (this.myPeerConnection != null) {
					// console.log('handleLeave  --------signalingState = ', this.myPeerConnection.signalingState);
					if (this.myPeerConnection.signalingState == 'closed') {
						this.handleRelease();
					} else {
						this.myPeerConnection.getSenders().forEach(sender => {
							// console.log('removeTrack  ', sender);
							that.myPeerConnection.removeTrack(sender);
						});
						this.myPeerConnection.close();

						setTimeout(() => {
							if (that.myPeerConnection != null) {
								if (that.myPeerConnection.signalingState == 'closed') {
									that.handleRelease();
								}
							}
						}, 100);

					}

				}
				this.videoplaying = false;
				this.RTCPeerConnectionCreated = false;
				this.StartCalled = false;
				this.IceCandidate.splice(0, this.IceCandidate.length);
			},
			handleRelease() {
				// console.log('handleRelease  ========');
				if (this.myPeerConnection != null) {
					this.myPeerConnection.onicecandidate = null;
					this.myPeerConnection.onaddstream = null;
					this.myPeerConnection.ontrack = null;
					this.myPeerConnection.onsignalingstatechange = null;
					this.myPeerConnection.onicegatheringstatechange = null;
					this.myPeerConnection = null;
				}
				if (this.IsFailCreate == false) {
					this.IsReconnect = true;
				}


			},
			async handleOffer(data) {
				var that = this;
				this.IsReconnect = false;
				// console.log("Offer --- ---- sdp  :\n", data.sdp);
				if (this.RTCPeerConnectionCreated == false) {
					this.initPeerConnection();
				}
				if (this.RTCPeerConnectionCreated == false) {
					// console.log("handleOffer Failed   RTCPeerConnectionCreated = ", this.RTCPeerConnectionCreated);
					this.sendDisconnect();
					this.IsReconnect = false;
					this.IsFailCreate = true;
				}
				// console.log("  setRemoteDescription --------");
				let nativeRTCSessionDescription = (window.mozRTCSessionDescription || window.RTCSessionDescription);
				try {
					await this.myPeerConnection.setRemoteDescription(new nativeRTCSessionDescription({
						type: 'offer',
						sdp: data.sdp
					}));
				} catch (err) {
					console.log("Error when setRemoteDescription-----------------------------", err.message);
					that.IsReconnect = true;
					this.IsFailCreate = true;
					return;
				}


				await this.myPeerConnection.createAnswer().then(function(answer) {
					that.myPeerConnection.setLocalDescription(answer);
					// console.log("Answer sdp :\n" + answer.sdp);
					that.sendToServer({
						"eventName": "__answer",
						"data": {
							"sessionId": that.sessionId,
							"sessionType": "IE",
							"messageId": that.newGuid(),
							"from": that.meid,
							"to": that.peerid,
							"type": answer.type,
							"sdp": answer.sdp
						}
					});
				}).catch(function(error) {
					console.log("Error when create  Answer-----------------------------", error.message);
					that.sendDisconnect();
					that.IsReconnect = true;
					this.IsFailCreate = true;
				});


			},
			sendDisconnect() {
				this.sendToServer({
					"eventName": "__disconnected",
					"data": {
						"sessionId": this.sessionId,
						"sessionType": "IE",
						"messageId": this.newGuid(),
						"from": this.meid,
						"to": this.peerid
					}
				});
			},
			handleCandidate(data) {
				var obj = {};
				try {
					obj = JSON.parse(data.candidate);
				} catch (e) {
					console.log("");
				}

				if (this.myPeerConnection != null && this.RTCPeerConnectionCreated == true) {
					// console.log("candidate --- ----   :", obj.candidate);
					var candidate = new RTCIceCandidate({
						sdpMLineIndex: obj.sdpMLineIndex,
						candidate: obj.candidate
					});
					this.myPeerConnection.addIceCandidate(candidate);
				} else {
					this.IceCandidate.push(obj);
				}
			},
			initPeerConnection() {
				try {
					console.log('initPeerConnection create PeerConnection configuration =', this.configuration);
					this.myPeerConnection = new RTCPeerConnection(this.configuration);
					if (this.myPeerConnection != null) {
						if ("addTrack" in this.myPeerConnection) {
							if (this.stream != null) {
								this.stream.getTracks().forEach(track => {
									this.myPeerConnection.addTrack(track, this.stream);
									console.log('PeerConnection use addTrack type', track.kind);
									if (track.kind === 'audio') {
										track.enabled = this.mute;
									}
								});
							} else {
								console.log('PeerConnection  addTrack  stream is null');
							}
						} else {
							if (this.stream != null) {
								this.myPeerConnection.addStream(this.stream);
								this.stream.getTracks().forEach(track => {
									console.log('PeerConnection use addStream type', track.kind);
									if (track.kind === 'audio') {
										track.enabled = this.mute;
									}
								});
							} else {
								console.log('PeerConnection  addStream is null');
							}
						}
						if ("ontrack" in this.myPeerConnection) {
							this.myPeerConnection.ontrack = this.handleRemoteTrackAdded;
						} else {
							this.myPeerConnection.onaddstream = this.handleRemoteStreamAdded;
						}
						this.myPeerConnection.onicecandidate = this.handleIceCandidate;
						this.myPeerConnection.oniceconnectionstatechange = this.handleIceConnectionStateChangeEvent;
						this.myPeerConnection.onicegatheringstatechange = this.handleIceGatheringStateChangeEvent;
						this.myPeerConnection.onsignalingstatechange = this.handleSignalingStateChangeEvent;
						//myPeerConnection.onnegotiationneeded = handleNegotiationNeededEvent;
						if (this.IsLocalDataChannel == true) {
							try {
								this.myDataChannel = this.myPeerConnection.createDataChannel("mydatachannel");
								if (this.myDataChannel) {
									this.myDataChannel.onopen = this.handleDataChannelOnOpen;
									this.myDataChannel.onclose = this.handleDataChannelOnClose;
									this.myDataChannel.onmessage = this.handleDataChannelOnMessage;
									this.myDataChannel.onerror = this.handleDataChannelOnError;
								}
							} catch (error) {
								console.log("data_channel_create_error  ");
							}
						}
						console.log('Sucessed to create PeerConnection');
						this.RTCPeerConnectionCreated = true;
					} else {
						console.log('Failed to create PeerConnection');
						this.RTCPeerConnectionCreated = false;
					}
				} catch (e) {
					console.log('Failed to create PeerConnection, exception: ' + e.message);
					this.RTCPeerConnectionCreated = false;
					return;
				}
			},
			getObjectURL(stream) {
				var url = null;
				try {
					if (window.createObjectURL != undefined) {
						url = window.createObjectURL(stream);
						console.log("window createObjectURL", url);
					} else if (window.URL != undefined) {
						url = window.URL.createObjectURL(stream);
						console.log("window window.URLcreateObjectURL ", url);
					} else if (window.webkitURL != undefined) {
						url = window.webkitURL.createObjectURL(stream);
						console.log("window.webkitURL.createObjectURL ", url);
					}
				} catch (error) {
					url = null;
				}
				return url;
			},


			handleRemoteTrackAdded(e) {
				this.remoteMediaStream = e.streams[0];
				console.log("handleRemoteTrackAdded", JSON.stringify(e));
				if (this.remoteVideo != null) {
					console.log("handleRemoteTrackAdded attachStream srcObject stream id = ", e.streams[0].id);
					e.streams[0].getAudioTracks().forEach(track => {
						console.log('handleRemoteTrackAdded  type', track.kind);
						if (track.kind === 'audio') {
							// 创建音频上下文
							const audioCtx = new (window.AudioContext || window.webkitAudioContext)();

							// 创建媒体流源，连接到音频上下文
							const source = audioCtx.createMediaStreamSource(new MediaStream([track]));

							// 创建增益节点
							const gainNode = audioCtx.createGain();
							gainNode.gain.value = 6; // 设置增益值为2，可以根据需要调整

							// 连接音频源和增益节点
							source.connect(gainNode);
							gainNode.connect(audioCtx.destination);
						}
					});
					this.remoteVideo.srcObject = e.streams[0];
					if (this.IsSystemAudioDeviceOK == false) {
						this.remoteVideo.muted = false;
						// if (this.isIos) {
						//     this.remoteVideo.muted = true;
						// }
					}
				} else {
					console.log("handleRemoteTrackAdded  video view is null");
				}
			},

			// handleRemoteTrackAdded(e) {
			// 	this.remoteMediaStream = e.streams[0];
			// 	console.log("handleRemoteTrackAdded", JSON.stringify(e));
			// 	if (this.remoteVideo != null) {
			// 		console.log("handleRemoteTrackAdded attachStream srcObject stream id = ", e.streams[0].id);
			// 		e.streams[0].getTracks().forEach(track => {
			// 			console.log('handleRemoteTrackAdded  type', track.kind);
			// 			if (track.kind === 'audio') {
			// 				track.enabled = this.speak;
			// 			}
			// 		});
			// 		this.remoteVideo.srcObject = e.streams[0];
			// 		if (this.IsSystemAudioDeviceOK == false) {
			// 			this.remoteVideo.muted = false;
			// 			// if (this.isIos) {
			// 			// 	this.remoteVideo.muted = true;
			// 			// }
			// 		}
			//
			// 	} else {
			// 		console.log("handleRemoteTrackAdded  video view is null");
			// 	}
			// },




			handleRemoteStreamAdded(e) {
				this.remoteMediaStream = e.stream;
				if (this.remoteVideo != null) {
					if ("srcObject" in this.remoteVideo) {
						console.log("handleRemoteStreamAdded attachStream srcObject stream id = ", e.stream.id);
						this.remoteVideo.srcObject = e.stream;
						e.stream.getTracks().forEach(track => {
							console.log('handleRemoteTrackAdded  type', track.kind);
							if (track.kind === 'audio') {
								track.enabled = this.speak;
							}
						});

					} else {
						var objUrl = this.getObjectURL(e.stream);
						console.log("handleRemoteStreamAdded attachStream getObjectURL stream id = ", e.stream.id);
						this.remoteVideo.src = objUrl;
						e.stream.getTracks().forEach(track => {
							console.log('handleRemoteTrackAdded  type', track.kind);
							if (track.kind === 'audio') {
								track.enabled = this.speak;
							}
						});

					}
				}
			},
			handleIceCandidate(event) {
				if (event.candidate) {
					console.log('onicecandidate: ' + event.candidate.candidate);
					this.sendToServer({
						"eventName": "__ice_candidate",
						"data": {
							"sessionId": this.sessionId,
							"sessionType": "IE",
							"messageId": this.newGuid(),
							"to": this.peerid,
							"from": this.meid,
							"candidate": JSON.stringify({
								'candidate': event.candidate.candidate,
								'sdpMid': event.candidate.sdpMid,
								'sdpMLineIndex': event.candidate.sdpMLineIndex
							})
						}
					});
				}
			},
			handleIceConnectionStateChangeEvent(event) {
				if (this.myPeerConnection == null) {
					return;
				}

				console.log("*** ICE connection state changed to " + this.myPeerConnection.iceConnectionState, event);
				if (event.target == this.myPeerConnection) {
					console.log("*** ICE connection state changed to ", event.target.iceConnectionState);

					switch (this.myPeerConnection.iceConnectionState) {
						case "closed":
							this.handleRelease();
							break;
						case "failed":
						case "disconnected":
							if (this.RTCPeerConnectionCreated == true) {
								this.handleLeave();
								this.sendDisconnect();
							}


							break;
						case "connected":
							this.videoplay();
							break;
					}


				}

			},
			handleIceGatheringStateChangeEvent(event) {
				if (this.myPeerConnection == null) {
					return;
				}
				if (event.target == this.myPeerConnection) {
					console.log("*** ICE gathering state changed to: " + event.target.iceGatheringState);
				}


			},
			handleSignalingStateChangeEvent(event) {
				if (this.myPeerConnection == null) {
					return;
				}
				if (event.target == this.myPeerConnection) {
					console.log("*** WebRTC signaling state changed to: " + event.target.signalingState);
					switch (this.myPeerConnection.signalingState) {
						case "closed":
							this.handleRelease();
							break;
					}
				}
			},
			handleDataChannelOnOpen() {
				console.log('handleDataChannelOnOpen');
				if (this.myDataChannel) {
					/*
          this.myDataChannel.send(JSON.stringify({
             "eventName": "__post_message",
             "data": {
               "sessionId": this.sessionId,
               "sessionType": "IE",
               "messageId": "fdafdafdafdfafdaf",
               "to": this.peerid,
                "from":this.meid,
                "message": "fafdafdfdafdf"
                }
            }));
         }
         */

					this.myDataChannel.send(JSON.stringify({
						"title": "handleDataChannelOpen",
						"sequence": 0,
						"payload": {
							"alarm_audio": true
						}
					}));
				}





			},
			handleDataChannelOnClose(event) {
				console.log('handleDataChannelOnClose ', event);
				this.hangup();
			},
			handleDataChannelOnMessage(message) {
				console.log('handleDataChannelOnMessage ', message);
				var json;
				json = JSON.parse(message.data);
				if (json.type === '__file') {
					console.log('handleDataChannelOnClose recive message data', json.data);
				} else if (json.type === '__msg') {
					console.log('handleDataChannelOnClose recive message data', json.data);
				} else {
					console.log('handleDataChannelOnClose recive message data', json.data);
				}
			},
			handleDataChannelOnError(err) {
				console.log('handleDataChannelOnError ', err);
			},
			close() {
				if (this.socketTask && this.socketTask.close) {
					this.socketTask.close()
				}
			},
			newGuid() {
				let s4 = function() {
					return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
				}
				return (s4() + s4() + "-" + s4() + "-4" + s4().substr(0, 3) + "-" + s4() + "-" + s4() + s4() + s4())
					.toUpperCase();
			},
			streamHandler(mystream) {
				this.CheckedgetUserMedia = true;
				window.localStream = mystream;
				this.stream = mystream;
				console.log("streamHandler  stream = ", this.stream);
				if ("getTracks" in mystream) {
					console.log('streamHandler getTracks');
					if (mystream != null) {
						mystream.getTracks().forEach(track => {
							console.log('streamHandler getTracks ', track);
							if (track.kind === "audio") {
								this.IsLocalAudioTrack = true;
								track.enabled = true;
							} else if (track.kind === "video" && this.allowvideo) {
								this.IsLocalVideoTrack = true;
								track.enabled = (this.ability == 1);
							}
						});
					}
				}
				if (this.StartCalled == false && this.IsWebSocketCreateed == true) {
					console.log("streamHandler  start call");
					this.Call();
				}
			},
			errorHandler(error) {
				console.log("errorHandler", error);
				console.log("---error：----", error.name, error.message);
				this.CheckedgetUserMedia = true;
				if (this.StartCalled == false && this.IsWebSocketCreateed == true) {
					console.log("streamHandler  errorHandler");
					this.Call();
				}

			},
			videoplay() {

				var that = this;
				if (this.videoplaying == false) {
					this.videoplaying = true;
					var playPromise = this.remoteVideo.play();
					if (playPromise) {
						playPromise.then(() => {
							that.videoplaying = true;
							console.log("<video>  play");

							if (that.imcall)
								that.Callon();

						}).catch((e) => {
							that.videoplaying = false;
							console.log("<video> play error", e.message);
						});
					}
				}
			},
			OnVideoPlay() {
				console.log("<video> event OnVideoPlay------");
			},
			OnVideoLoadedMetaData() {
				// console.log("<video> event OnVideoLoadedMetaData----------------");
				this.videoplay();
			},
			OnVideoCanPlay() {
				// console.log("<video>  OnVideoCanPlay-----videoWidth = " + this.remoteVideo.videoWidth);
				// console.log("<video>  OnVideoCanPlay-----videoHeight = " + this.remoteVideo.videoHeight);
				// console.log("<documentElement>  OnVideoCanPlay------clientWidth = " + document.documentElement
				// 	.clientWidth);
				// console.log("<documentElement>  OnVideoCanPlay------clientHeight = " + document.documentElement
				// .clientHeight);
				var loading = document.getElementById('loading');
				if (loading != null)
					loading.style.display = "none";
				var canvas = document.getElementById('canvas');
				if (canvas != null) {
					canvas.style.width = this.remoteVideo.videoWidth;
					canvas.style.height = this.remoteVideo.videoHeight;
				}


				// var Videos = document.getElementById("videos");
				// if (this.ability < 1) {
				// 	Videos.style.display = "none";
				// }
				// Videos.style.width = "100%";

				// var temheight = document.documentElement.clientWidth * this.remoteVideo.videoHeight / this.remoteVideo
				// .videoWidth;
				// if (temheight > document.documentElement.clientHeight) {
				// if (this.isIos) {
				//Videos.style.height= Math.floor(document.documentElement.clientWidth*this.remoteVideo.videoHeight/this.remoteVideo.videoWidth)+"px";
				// } else {
				//Videos.style.height= Math.floor(document.documentElement.clientHeight)+"px";
				// }
				// } else {
				// Videos.style.height= Math.floor(document.documentElement.clientWidth*this.remoteVideo.videoHeight/this.remoteVideo.videoWidth)+"px";
				// }


				// console.log("<video>----------------height " + Videos.style.height);
				if (this.remoteVideo.muted == true) {
					if (this.isIos == false) {
						this.remoteVideo.muted = false;
					}
					console.log("<video>----------------muted = true");
				} else {
					console.log("<video>----------------muted = false");
				}

			},
			OnVideoError() {
				console.log("<video> event OnVideoError----------------");
			},
			OnVideoLoadedData() {
				console.log("<video> event OnVideoLoadedData----------------");
			},
			turn90() {
				this.rotation += 90;
				this.remoteVideo.style.transform = "rotate(" + this.rotation + "deg)";

				// 根据旋转角度更新按钮图标方向
				var rotateIcon = document.getElementById("rotateIcon");
				rotateIcon.style.transform = "rotate(" + this.rotation + "deg)";

			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.logo {
		width: 13vw;
		height: 13vw;
	}

	article {
		height: 100vh;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-around;
		align-items: center;
	}

	.divhead {
		width: 100vw;
		height: 100vw;

	}

	.divcontrol {
		width: 100%;
		background-color: #000000;
		height: 10vh;
	}

	.divcontxt {}

	.divctrl {
		width: 100%;
		/* Safari */
		-webkit-flex-direction: row;
		/* Safari 6.1+ */

		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-around;
		align-items: center;
		margin-top: -2vh;
	}

	.imgbutton {
		margin: 0px 5px 5px 0px;
		width: 50px;
		height: 50px;
	}

	.imgbutton1 {
		margin: 0px 5px 5px 0px;
		width: 50px;
		height: 50px;
	}

	.imgbt {
		width: 100%;
		height: 100%;
	}


	.wpbutton {
		margin: 5px 5px 5px 0px;
		width: 50px;
		height: 50px;
		text-align: center;
		margin-left: 5%;
		margin-right: 5%;
		color: #ccc;
	}

	.arc {
		--width: 100%;
		--height: 100%;
		position: absolute;
		margin: auto;
		left: calc(var(--width)/2 - 25px);
		top: calc(var(--height)/2 - 25px);
		width: 50px;
		height: 50px;
		border-radius: 50%;
		border-top: 2px solid #ffea29;
		border-left: 1px solid transparent;
		border-right: 1px solid transparent;
		animation: rt 2s infinite linear;
	}

	.arc::before {
		position: absolute;
		margin: auto;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 0;
		height: 0;
		width: 35px;
		height: 35px;
		border-radius: 50%;
		border-top: 2px solid #8d29ff;
		border-left: 1px solid transparent;
		border-right: 1px solid transparent;
		animation: rt 4s infinite linear reverse;
		content: "";
	}

	.arc::after {
		position: absolute;
		margin: auto;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 0;
		height: 0;
		width: 0;
		height: 0;
		border-radius: 50%;
		border-top: initial;
		border-left: initial;
		border-right: initial;
		animation: cw 1s infinite;
		content: "";
		background: snow;
	}

	@keyframes rt {
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes cw {
		0% {
			width: 0;
			height: 0;
		}

		75% {
			width: 20px;
			height: 20px;
		}

		100% {
			width: 0;
			height: 0;
		}
	}

	.scale {
		background: #ddd;
		width: 100%;
		height: 3px;
		position: relative;
		margin: 0px 0px 0px 0px;
	}

	.scale span {
		background: #aaa;
		width: 8px;
		height: 16px;
		position: absolute;
		left: -2px;
		top: -6px;
		cursor: pointer;
		border-radius: 3px;
	}

	.scale div {
		background: #66D9EF;
		position: absolute;
		height: 3px;
		width: 0;
		left: 0;
		bottom: 0;
	}

	video {
		margin: 0px 0px 0px 0px;
		font-size: 16px;
		color: #FFF;
		background-color: #000000;
		object-fit: fill;
		width: 100%;
		height: 100%;
		muted: "true";
		preload: "auto";
		autoplay: "autoplay";
		x-webkit-airplay: "true";
		playsinline: "true";
		controls: "false";
		webkit-playsinline: "true";
		x5-video-player-type: "h5";
		x5-video-player-fullscreen: "true";
		x5-video-orientation: "portraint";
	}

	.roundbutton {
		display: none;
		height: 46px;
		width: 46px;
		border-radius: 50%;
		border: 1px solid #ffeb3b;
		background-color: #4DD0E1;
		color: white;
		padding: 3px;
		/* line-height: 50px;
		font-weight: 600; */
	}

	.roundbutton img {
		height: 30px;
		width: 30px;
		margin: auto auto;
	}

	.showact {
		display: flex;
	}

	.turn90 {
		position: absolute;

		right: 10px;
		top: 100px;
	}
</style>
